export const uploadList = [
    {
        label: '身份证(人像面)',
        fileName: 'idCardFileName', // 身份证件上传(人像面)
        fileUrl: 'idCardFileUrl',
        fileTemUrl: 'idCardFileTemUrl',
        fileId: 'idCardFileId',
        errMsg: '请上传身份证(人像面)',
        example: 'idCard.jpg',
        examplePicWidth: '330px',
        examplePicHeight: '200px',
        ocrFlag: 'idCardFont',
        isRequired: true
    },
    {
        label: '身份证(国徽面)',
        fileName: 'idCardBottomSideFileName', // 身份证背面上传（国徽面）
        fileUrl: 'idCardBottomSideFileUrl',
        fileTemUrl: 'idCardBottomSideFileTemUrl',
        fileId: 'idCardBottomSideFileId',
        errMsg: '请上传身份证(国徽面)',
        example: 'idCardBottomSize.jpg',
        examplePicWidth: '330px',
        examplePicHeight: '200px',
        ocrFlag: 'idCardBehind',
        isRequired: true
    },
    {
        label: '驾驶证',
        fileName: 'drivingLicenceFileName', // 驾驶证上传
        fileUrl: 'drivingLicenceFileUrl',
        fileTemUrl: 'drivingLicenceFileTemUrl',
        fileId: 'drivingLicenceFileId',
        errMsg: '请上传驾驶证',
        example: 'driverLicense.jpg',
        examplePicWidth: '520px',
        examplePicHeight: '185px',
        ocrFlag: 'driving',
        isRequired: true
    },
    {
        label: '从业资格证',
        fileName: 'empCertificateFileName', // 从业资格证上传
        fileUrl: 'empCertificateFileUrl',
        fileTemUrl: 'empCertificateFileTemUrl',
        fileId: 'empCertificateFileId',
        errMsg: '请上传从业资格证',
        example: 'empCertificate.jpg',
        examplePicWidth: '320px',
        examplePicHeight: '210px',
        ocrFlag: 'empCertificate',
        isRequired: false
    },
    {
        fileName: 'delegateFileName', // 委派函上传
        fileUrl: 'delegateFileUrl',
        fileTemUrl: 'delegateFileTemUrl',
        fileId: 'delegateFileId',
        errMsg: '请上传委派函',
        example: 'delegate.jpg',
        examplePicWidth: '500px',
        examplePicHeight: '680px',
        ocrFlag: ''
    }
];
